import * as fromRoot from '../../shared/reducers';
import {ActionReducerMap, createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import * as _ from 'lodash';
import { SalesStatisticListReducer, SalesStatisticListState, salesStatisticListStateSelectors } from './sales-statistic-list';
import { SalesStatistic } from '../models/sales-statistic';
import {OrdersStatisticListReducer, OrdersStatisticListState, ordersStatisticListStateSelectors} from './ordres-statistic-list';
import {OrdersStatistic} from '../models/orders-statistic';
import {SalesStatisticGoalsReducer, SalesStatisticGoalsState, salesStatisticGoalsStateSelectors} from './sales-statistic-goals';
import {SalesStatisticRevenuesReducer, SalesStatisticRevenuesState} from './sales-statistic-revenus';


export interface DashboardState {
  salesStatisticList: SalesStatisticListState;
  ordersStatisticList: OrdersStatisticListState;
  ordersStatisticGoals: SalesStatisticGoalsState;
  ordersStatisticRevenues: SalesStatisticRevenuesState;
}

export interface AppState extends fromRoot.AppState {
  dashboardState: DashboardState;
}

export const reducers: ActionReducerMap<DashboardState> = {
  salesStatisticList: SalesStatisticListReducer,
  ordersStatisticList: OrdersStatisticListReducer,
  ordersStatisticRevenues: SalesStatisticRevenuesReducer,
  ordersStatisticGoals: SalesStatisticGoalsReducer,
};

const getDashboardState = createFeatureSelector('dashboard');

const rootSelectors = {
  salesStatisticList: createSelector(getDashboardState, (state: DashboardState) => _.get(state, 'salesStatisticList')),
  ordersStatisticList: createSelector(getDashboardState, (state: DashboardState) => _.get(state, 'ordersStatisticList')),
  ordersStatisticRevenues: createSelector(getDashboardState, (state: DashboardState) => _.get(state, 'ordersStatisticRevenues')),
  ordersStatisticGoals: createSelector(getDashboardState, (state: DashboardState) => _.get(state, 'ordersStatisticGoals')),
};

export interface Selectors {
  getSalesStatistics: MemoizedSelector<AppState, SalesStatistic[]>;
  getSalesStatisticsCount: MemoizedSelector<AppState, number>;
  getOrdersStatistics: MemoizedSelector<AppState, OrdersStatistic[]>;
  getOrdersStatisticsCount: MemoizedSelector<AppState, number>;
  // tslint:disable-next-line:no-any
  getOrdersStatisticRevenues: MemoizedSelector<AppState, any[]>;
  // tslint:disable-next-line:no-any
  getOrdersStatisticGoals: MemoizedSelector<AppState, any[]>;
}

export const selectors: Selectors = {
  getSalesStatistics: createSelector(rootSelectors.salesStatisticList, salesStatisticListStateSelectors.array),
  getSalesStatisticsCount: createSelector(rootSelectors.salesStatisticList, salesStatisticListStateSelectors.count),
  getOrdersStatistics: createSelector(rootSelectors.ordersStatisticList, ordersStatisticListStateSelectors.array),
  getOrdersStatisticsCount: createSelector(rootSelectors.ordersStatisticList, ordersStatisticListStateSelectors.count),
  getOrdersStatisticRevenues: createSelector(rootSelectors.ordersStatisticRevenues, ordersStatisticListStateSelectors.array),
  getOrdersStatisticGoals: createSelector(rootSelectors.ordersStatisticGoals, salesStatisticGoalsStateSelectors.array),
};
